import React, { useState, useEffect } from "react";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import NotFound from "./pages/NotFound";
import Layout from "./pages/Layout";
import "./index.css"

import ProjectDetails from "./pages/ProjectDetails";
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ landingPageData }) => (
  <>
   
    <Header data={landingPageData.Header} />
    <About data={landingPageData.About} />
    <Services data={landingPageData.Services} />
    <Gallery />
    <Contact data={landingPageData.Contact} />
  </>
);

const Test = ({ data }) => (
    
  <>
    <ProjectDetails data={data.Gallery}/> 
  </>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const router = createBrowserRouter([
    {
      element: <Layout />,
      children: [
        { path: "/", element: <HomePage landingPageData={landingPageData} /> },
        { path: "/project/:id", element: <Test data={landingPageData}/> },
        { path: "*", element: <NotFound /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
